'use client';
// useToggle Hook
import { useCallback, useState } from 'react';

type UseToggleReturn = [boolean, () => void, (value: boolean) => void];

export const useToggle = (initialValue: boolean = false): UseToggleReturn => {
  const [value, setValue] = useState<boolean>(initialValue);

  const toggle = useCallback(() => {
    setValue((prev) => !prev);
  }, []);

  const setToggle = useCallback((newValue: boolean) => {
    setValue(newValue);
  }, []);

  return [value, toggle, setToggle];
};

export default useToggle;
